/**
 * @fileoverview Componente Organism para visualización completa de mensajes de audio en la bandeja de entrada
 * @module AudioMessageMC
 * @category Component - Organism
 * @since 1.0.0
 * @version 3.1.0
 */

import React, { memo } from 'react';
import MessageStatusMC from './MessageStatusMC';
import GroupSenderMC from './GroupSenderMC';
import AudioMC from '../../../components/AudioMC';

/**
 * Componente Organism para visualización completa de mensajes de audio en la bandeja de entrada.
 *
 * Encapsula la representación visual completa de un mensaje de audio, incluyendo
 * información del remitente, reproductor de audio y estado del mensaje en un layout
 * optimizado para diferentes plataformas de mensajería.
 */
/**
 * `internalUrl` primero: una nota de voz se entrega a WhatsApp en Ogg/Opus, que
 * es el único formato que WhatsApp pinta con el micrófono verde, pero Safari no
 * sabe decodificarlo. El servidor guarda además una copia en m4a y es esa la
 * que suena aquí. Sin ella (mensajes viejos, o si la conversión falló) cae a la
 * URL entregada, que es lo que se venía usando.
 */
export const AUDIO_URL_FIELDS = ['internalUrl', 'contentMediaUrl'];

const AudioMessageMC = memo(({ conversation, message }) => (
  <div className="tw-w-full">
    <GroupSenderMC message={message} />
    <div className="tw-flex tw-flex-col tw-w-full">
      <AudioMC
        data={message}
        platform={conversation.platform}
        urlField={AUDIO_URL_FIELDS}
        className="tw-block tw-w-full tw-outline-none"
      />
      <MessageStatusMC message={message} platform={conversation.platform} />
    </div>
  </div>
));

AudioMessageMC.displayName = 'AudioMessageMC';

export default AudioMessageMC;
